import * as _ from "lodash-es";
import { getCurrentInstance, inject, type InjectionKey } from "vue";

export function injectWithSelf<T>(
	symbol: InjectionKey<T>,
	def: T | undefined = undefined
): T | undefined {
	const vm = getCurrentInstance() as any;

	return vm?.provides[symbol as any] || inject(symbol, def);
}

export function safeClone<T>(value: T): T {
	return _.cloneDeepWith(value, (value) => {
		if (value instanceof File || value instanceof Date) {
			return value;
		}
		return undefined;
	});
}
